export const EXPENSES_ENABLED_CARD_TITLE = "Expenses";
export const EXPENSES_DISABLED_CARD_TITLE = "Turn on Expenses";

export const EXPENSES_ENABLED_COPY =
  "Employees can submit reimbursement requests based on the settings and criteria below.";
export const EXPENSES_DISABLED_COPY =
  "Employees cannot submit reimbursement requests but admins can edit the settings.";
